<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-row class="hidden-md-and-up" no-gutters>
            <v-col cols="12">
                <v-toolbar dense height="30px" color="primary" dark>
                    <v-toolbar-title
                        v-html="sectionTitle"
                        class="subtitle-2 text-uppercase"
                    ></v-toolbar-title>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="auto" class="hidden-sm-and-down pr-2">
                <v-card
                    elevation-0
                    class="ml-4 pr-3 pt-4"
                    color="secondary"
                    height="80px"
                    width="200px"
                    dark
                >
                    <p
                        class="font-weight-bold text-right text-uppercase subheading"
                        v-html="sectionTitle"
                    ></p>
                </v-card>
            </v-col>
            <v-col md="auto" class="hidden-sm-and-down">
                <v-divider vertical class="mx-3 hidden-sm-and-down"></v-divider>
            </v-col>

            <v-col cols="12" :md="wideFirstCol ? 7 : 5" class="px-2 pb-0">
                <slot name="col-1"></slot>
            </v-col>
            <v-col class="px-2">
                <slot name="col-2"></slot>
            </v-col>
            <v-col cols="12" class="hidden-sm-and-down">
                <v-divider class="ml-1"></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "form-section",
    props: {
        sectionTitle: {
            type: String,
            required: true,
        },
        wideFirstCol: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
